import React, { useState } from 'react';
import { TextInput, InputWrapper, ToolTip, FontBody } from '../index.styled';
import Typography from '../../Typography';
import blueCheck from '../../../icons/blue_check.svg';
import exclamationMark from '../../../icons/exclamation_mark.svg';
export const TextInputContainer = ({
  name,
  placeholder,
  setIsEmailValid,
  setIsNameValid
}) => {
  const [coloredInput, setColoredInput] = useState('gray');
  const [inputSuccess, setSuccess] = useState(undefined);
  const [inputError, setInputError] = useState(undefined);
  const language = (window.localStorage.i18nextLng === 'ja') ? 'ja' : 'en';
  const emailError = (language === 'ja') ? '有効なメールアドレスを入力してください。' : 'Please enter a valid email address';
  const nameError = (language === 'ja') ? '有効なお名前を入力してください。' : 'Please enter a valid name';
  let isEmail = (name === 'email') ? true : false;
  let isName = (name === 'name') ? true : false;


  const validate = (e) => {
    if (name === 'email' || name === 'name'){
      const inputValue = e.target.value      
      let success, error = undefined;
      let color = 'gray';

      if (name === 'email'){
        const regTest = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(inputValue);
        if(regTest) {
          success = true;
          setIsEmailValid(true);
        }
        else {
          error = true;
          setIsEmailValid(false);
        }
        
      }else if (name === 'name'){
        if(inputValue !== '' && inputValue.length >= 2) {
          success = true;
          setIsNameValid(true);
        }
        else {
          error = true;
          setIsNameValid(true);
        }
      }
      if (success) color = 'blue';
      else if (error) color = 'red';

      setColoredInput(color)
      setSuccess(success)
      setInputError(error)
    } 
  } 

  return (
    <FontBody>
      {
        (isEmail && inputError) && (
          <ToolTip>{emailError}</ToolTip>
        )
      }
      {
        (isName && inputError) && (
          <ToolTip>{nameError}</ToolTip>
        )
      }
      <TextInput isValid={coloredInput}>
        <Typography.Body>
          <InputWrapper>
            <input name={name} title={name} id={name} aria-labelledby={name} placeholder={placeholder} type={(name === 'email') ? "email" : "text"} onBlur={e => validate(e)} />
            {inputError && <img src={exclamationMark} alt='error' width='16px' height='16px' />}
            {inputSuccess && <img src={blueCheck} alt='correct' width='16px' height='16px' />}
          </InputWrapper>
        </Typography.Body>
      </TextInput>
    </FontBody>
  );
};